import script from "./HilfeServiceportal.vue?vue&type=script&setup=true&lang=js"
export * from "./HilfeServiceportal.vue?vue&type=script&setup=true&lang=js"

import "./HilfeServiceportal.vue?vue&type=style&index=0&id=0dbe5629&lang=css"

const __exports__ = script;

export default __exports__